import { create } from "zustand";

type PolicyData = {
  policy_number: string;
  policy_type: string;
  policy_status: string;
  product_history: string[];
  member_name: string;
  member_contact_number: string;
  [key: string]: any;
};

type PolicyStore = {
  policyData: PolicyData | null;
  setPolicyData: (data: PolicyData | null) => void;
};

export const usePolicyStore = create<PolicyStore>((set) => ({
  policyData: null,
  setPolicyData: (data) => set({ policyData: data }),
}));
